import { render } from "./GeneralItem.vue?vue&type=template&id=7d8ec83a&scoped=true"
import script from "./GeneralItem.vue?vue&type=script&lang=js"
export * from "./GeneralItem.vue?vue&type=script&lang=js"

import "./GeneralItem.vue?vue&type=style&index=0&id=7d8ec83a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8ec83a"]])

export default __exports__